import React, { memo, useEffect, useRef, useState } from 'react';

// Индикатор фазы (M7 review-fix): держит секундомер в собственном
// локальном состоянии — тик 1 с ре-рендерит только этот блок, а не всю
// страницу. Родитель передаёт сменяемые props: isProcessing / currentPhase.
const PhaseIndicator = ({ isProcessing = false, currentPhase = null }) => {
  const [phaseElapsed, setPhaseElapsed] = useState(0);
  const [thinkingDots, setThinkingDots] = useState(1);
  const phaseStartRef = useRef(null);

  // Сброс секундомера при старте обработки и смене фазы
  useEffect(() => {
    if (!isProcessing) return undefined;
    phaseStartRef.current = Date.now();
    setPhaseElapsed(0);
    return undefined;
  }, [isProcessing, currentPhase]);

  // Тик 1 с (m1: dots гейтится по !currentPhase, чтобы не тикать
  // вхолостую, когда точки не рендерятся)
  useEffect(() => {
    if (!isProcessing) {
      phaseStartRef.current = null;
      setPhaseElapsed(0);
      setThinkingDots(1);
      return undefined;
    }
    const tick = () => {
      if (phaseStartRef.current !== null) {
        setPhaseElapsed(Math.floor((Date.now() - phaseStartRef.current) / 1000));
      }
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [isProcessing]);

  useEffect(() => {
    if (!isProcessing || currentPhase) return undefined;
    const interval = setInterval(() => {
      setThinkingDots(d => d >= 3 ? 1 : d + 1);
    }, 500);
    return () => clearInterval(interval);
  }, [isProcessing, currentPhase]);

  if (!isProcessing) return null;

  return (
    <div className="pd-msg-left pd-thinking">
      {currentPhase
        ? `Фаза: ${currentPhase} · ${phaseElapsed} с`
        : 'Думает' + '.'.repeat(thinkingDots)}
    </div>
  );
};

export default memo(PhaseIndicator);
